import { SignatureField } from '@modusign/react-signing/types';

export function isSignerResizableSignatureField(field: SignatureField | null) {
  return field?.size.width === 0 && field?.size.height === 0;
}
